import {useCallback} from "react";
import {PersonCapabilityType} from "@ots-frontend/ots-data";
import {Switch} from "@mantine/core";
import {useAuth} from "../../../providers/AuthProvider/AuthProvider";
import {
  BasePersonCapabilityDataTable,
  BasePersonCapabilityDataTableProps
} from "./BasePersonCapabilityDataTable";

export type PersonCapabilityDataTableProps = Omit<BasePersonCapabilityDataTableProps, 'renderActions'> & {
  permPrefix: string
  selectedCapabilities: Set<PersonCapabilityType>
  toggleCapability: (cap: PersonCapabilityType) => void
}

export const PersonCapabilityDataTable = (props: PersonCapabilityDataTableProps) => {
  const {
    permPrefix,
    selectedCapabilities,
    toggleCapability,
    ...rest
  } = props

  const {hasAccess} = useAuth()

  const renderActions = useCallback((record: PersonCapabilityType, index: number) => {
    return (
      <Switch
        disabled={!hasAccess(`${permPrefix}_edit`)}
        checked={selectedCapabilities.has(record)}
        onChange={() => toggleCapability(record)}
      />
    )
  }, [hasAccess, permPrefix, selectedCapabilities, toggleCapability])

  return (
    <BasePersonCapabilityDataTable
      {...rest}
      renderActions={renderActions}
    />
  )
}
